export const GET_CART_GOODS = "GET_CART_GOODS";
export const GET_CART_GOOD_BY_ID = "GET_CART_GOOD_BY_ID";
export const UPDATE_CART_GOOD = "UPDATE_CART_GOOD";
export const DELETE_CART_GOOD = "DELETE_CART_GOOD";
export const CREATE_CART_GOOD = "CREATE_CART_GOOD";
